<template>
	<div>
		<div v-bind:class="{'hoverable':!loading, 'rounded bg-loading':loading}">
			<a class="hoverable-overlay rounded" href="#" v-on:click.prevent="loadFile">
				Cambiar 
				<br>
				Logo
			</a>
			<div v-if="loading" class="d-flex" :style="'width: '+width+'; height: '+height+'; align-items: center; justify-content: center'">
				<span>
					<i class="fa fa-spinner fa-pulse fa-3x fa-fw text-white"></i>
				</span>
	            <span class="sr-only">Cargando...</span>
			</div>
			<img :src="image" alt="Logo" class="img-thumbnail rounded-circle" :style="'width: '+width+'; height: '+height+'; object-fit: scale-down; object-position: center; background-color: rgba(0,0,0,0.1)'" v-else/>
	        <input :id="idForm" type="file" :name="nameForm" ref="logo" v-on:change="onFileChange" accept="image/*" class="d-none">
		</div>
		<div v-if="showRemove">
			<a href="#" @click.prevent="deleteFile">Remover</a>
		</div>
	</div>
</template>
<script>
	export default{
		props: {
            route: String,
            id: String,
            name: String,
            height: String,
            width: String
        },

		data(){
			return {
				logo: '',
				image: '',
				loading: false,
				showRemove: false,
			}
		},

		mounted(){
			this.cleanField();
			if (this.route != '') {
				this.showRemove = true;
			}
		},

		methods: {
			loadFile(){
				this.$refs.logo.click();
			},

			onFileChange(e) {
		    	var file = e.target.files || e.dataTransfer.files;
		    	this.logo = this.$refs.logo.files[0];
		    	
		    	if (!this.logo)
		    		return;
		    	//this.createImage(file[0])
		    	this.uploadFile();
		    },

			createImage(file) {
		    	var image = new Image();
		    	var reader = new FileReader();
		    	var vm = this;

		    	reader.onload = (e) => {
		    		vm.image = e.target.result;
		     	};
		    	reader.readAsDataURL(file);
		    },

		    uploadFile(){
				var $module = this;
				let formData = new FormData();
	            formData.append('logo', this.logo);
	            this.loading = true;

	            axios.post( '/api/configuraciones/logo',
	               	formData,
	                {
	                	headers: {
	                    	'Content-Type': 'multipart/form-data'
	                	}
	              	}
	        	).then(function(response){
	        		$module.$toasted.show('El logo ha sido actualizado.');
	        		$module.image = response.data;
	        		$module.showRemove = true;
	        	})
	        	.catch(function(error){
	        		console.log(error.response);
	        		$module.$toasted.show('Error al actualizar logo.');
	          		$module.cleanField();
	        	}).then(() => {
	        		this.loading = false;
	        	});
			},

			deleteFile(){
				var $module = this;
				this.loading = true;

	            axios.delete('/api/configuraciones/removelogo')
	            .then(function(response){
	        		$module.$toasted.show('El logo ha sido eliminado.');
	        		$module.cleanField();
	        		$module.setImageDefault();
	        		$module.showRemove = false;
	        	})
	        	.catch(function(error){
	        		console.log(error.response);
	        		$module.$toasted.show('Error al eliminar logo.');
	        	}).then(() => {
	        		this.loading = false;
	        	});
			},

			cleanField(){
				this.$refs.logo.value = '';
				this.image = this.routeImage || '';

				if (this.image == '') {
					this.setImageDefault();
				}
			},

			setImageDefault(){
				this.image = crm.url + '/images/logos/logo.png';
				this.showRemove = false;
			}
		},

		computed: {
		    routeImage: function () {
			    return this.route;
			},

			idForm: function(){
				return this.id || 'logo';
			},

			nameForm: function(){
				return this.name || 'logo';
			}
		},

		watch: {
			image: function (val) {
				$('#imgLogo').attr('src', val);
			},
		}
	}
</script>

<style>
	.hoverable {
		position: relative;
		display: block;
	}

	.hoverable:hover .hoverable-overlay {
		align-items: center;
		background-color: rgba(0,0,0,.3);
		color: #fff;
		display: flex;
		height: 100%;
		justify-content: center;
		position: absolute;
		text-align: center;
		width: 100%;
	}

	.hoverable-overlay {
		display: none;
	}

	.bg-loading {
		background-color: rgba(0,0,0,.3);	
	}

</style>